import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
// import TanStackQueryLayout from "../lib/tanstack-query/layout.tsx";
import type { QueryClient } from "@tanstack/react-query";
import type { AuthContextType } from "@/lib/keycloak/auth-context";
import { MatomoRouteTracker, useUserTracking } from "@/lib/matomo";
import { CookieConsentBanner } from "@/components/cookie-consent";
import { DocumentTitle } from "@/components/document-title";
import { HelpDrawerProvider } from "@/components/help";
import { NotFoundErrorPage } from "@/lib/error-boundary";

interface MyRouterContext {
	queryClient: QueryClient;
	auth: AuthContextType;
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
	component: RootComponent,
	notFoundComponent: NotFoundErrorPage,
});

function RootComponent() {
	// Track user identification for analytics
	useUserTracking();

	return (
		<>
			{/*
			 * DocumentTitle must stay above MatomoRouteTracker: the tracker reads
			 * document.title when it sends a page view, so the title has to be set
			 * first. Pinned by src/lib/matomo/route-tracker.test.tsx.
			 */}
			<DocumentTitle />
			<MatomoRouteTracker />
			<HelpDrawerProvider>
				<Outlet />
			</HelpDrawerProvider>
			<CookieConsentBanner />
			{/* <TanStackRouterDevtools /> */}
			{/* <TanStackQueryLayout /> */}
		</>
	);
}
